import type {SwatchType} from '@packages/systems/core/utils/StyleTypes';

export const getAllSwatchesToInclude = (
  swatchIds: Set<string>,
  swatchMap: Map<string, SwatchType>
) => {
  const swatches: Array<SwatchType> = [];
  swatchIds.forEach((id) => {
    const swatch = swatchMap.get(id);
    if (swatch) {
      swatches.push(swatch);
    }
  });

  return swatches;
};
